if (signedIn) {
    Brevo.push(function () {
        Brevo.identify({
            identifiers: {
                email_id: primaryEmail
            },
            attributes: {
                FIRSTNAME: firstName,
                LASTNAME: lastName
            },
        });
    });    
}


if (loginSucceeded && submitTag) {
    brevoPush('user_login_success');
    window.dataLayer.push({
        event: 'user_login_success',
        method: 'email'
    });
}

$(document).ready(function() {
    $('#headersearch').on('submit',function(){
        var headerSearchObj = {
            event: "event_search",
            search_term: $('#headersearchevents').val(),
            search_category: "event",
            page_path: "/",
            user_id: (user != '0') ? user : null,
            timestamp: new Date().toISOString()
        };
        if (submitTag){
            brevoPush('event_search', {search_term: $('#headersearchevents').val()});
            window.dataLayer.push(headerSearchObj);
        }
    });
    $('#faqs-link').on('click', function(){
        if (submitTag){
            brevoPush('faqs_page_click', {section_clicked: 'footer'});
            window.dataLayer.push({
                event: 'faqs_page_click',
                event_id: 'faqs_click_' + new Date().getTime(),
                page_path: window.location.pathname,
                timestamp: new Date().toISOString()
            });
        }
    });

    $('.social-links a[data-name]').on('click', function(){
        if(submitTag){
            brevoPush('social_icon_click', {platform: $(this).data('name')});
            window.dataLayer.push({
                event: 'social_icon_click',
                event_id: 'social_click_' + new Date().getTime(),
                social_network: $(this).data('name'),
                page_path: window.location.pathname,
                timestamp: new Date().toISOString()
            });
        }
    });
});